// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edge-menu-container {
  box-shadow: 0 0.1rem 0.23rem rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  background: #fff;
}

.edge-name {
  color: #393939;
}

.edge-type {
  color: rgb(0, 0, 0);
}

.link {
  font-size: 80%;
  text-decoration: none !important;
  transition: 0.3s;
  font-weight: 500;
  color: #217ed5;
  border-bottom: solid 2px transparent;
}
.link:hover {
  color: #1472ca;
  border-color: #1472ca;
}

.edge-int {
  color: rgb(0, 0, 0);
  font-weight: 500;
}

.edge-int-type {
  font-weight: 400;
}

.int-type {
  font-size: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/EdgeMenu/EdgeMenu.scss","webpack://./src/scss/globals.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EACE,gDAAA;EACA,mBCLc;EDMd,gBAAA;AAFF;;AAKA;EACE,cEMU;AFRZ;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBCdS;EDeT,cEpBU;EFqBV,oCAAA;AAFF;AAIE;EACE,cEGa;EFFb,qBEEa;AFJjB;;AAMA;EACE,mBElBU;EFmBV,gBC1BS;ADuBX;;AAMA;EACE,gBC/BU;AD4BZ;;AAMA;EACE,eAAA;AAHF","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n\n.edge-menu-container {\n  box-shadow: 0 .1rem .230rem rgba(0, 0, 0, 0.15);\n  border-radius: $border-radius;\n  background: #fff;\n}\n\n.edge-name {\n  color: $text-main;\n}\n\n.edge-type {\n  color: $text-ghost;\n}\n\n.link {\n  font-size: 80%;\n  text-decoration: none!important;\n  transition: 0.3s;\n  font-weight: $fw-heavy;\n  color: $palette-1;\n  border-bottom: solid 2px transparent;\n\n  &:hover {\n    color: $palette-1-dark;\n    border-color: $palette-1-dark;\n  }\n}\n\n.edge-int {\n  color: $text-ghost;\n  font-weight: $fw-heavy;\n}\n\n.edge-int-type {\n  font-weight: $fw-medium;\n}\n\n.int-type {\n  font-size: 100%;\n}\n","$border-radius: 10px;\n$big-radius: 16px;\n$radius-btn: 10px;\n$nav-radius: 12px;\n\n$fw-light: 300;\n$fw-medium: 400;\n$fw-heavy: 500;\n","$black: #011627;\n$white: #FDFFFC;\n$palette-1: #217ed5;\n// $palette-2: #074ba5;\n$palette-2: #52796F;\n$palette-3: #FF9F1C;\n$palette-4:rgba(239, 48, 48, 0.822);\n$palette-5: #748b80;\n// 5fa15a\n// eab271\n// 1d2d44d0\n$nav-outline: #eff;\n$nav-outline-hvr: rgba(#217ed5,.4);\n\n$text-ghost:rgb(0, 0, 0);\n$text-light: #717171;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$palette-1-light: #1890ff;\n$palette-2-light: #ffe9ee;\n\n$palette-1-dark: #1472ca;\n$palette-2-dark: #ab1236;\n$palette-3-dark: #bb781c;\n$palette-4-dark:rgba(243, 16, 16, 0.87);\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n$nav-back : #96c4a0;\n// 9ecf7d\n// f08585\n// 7dce82\n// rgb(152, 171, 196)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
